export const ENVIRONMENTS = Object.freeze({
    LIVE: 'LIVE',
    REVIEW_WEBAPP: 'REVIEW_WEBAPP',
    REVIEW: 'REVIEW',
    STAGING: 'STAGING',
    DEV: 'DEV',
    DEV_OLD: 'DEV_OLD'
});

export const getReviewEnvIdFromHost = () => {
    const reviewHostMatch = document.location.host.match(
        /^(insights-webapp|surveys-webapp|insights|surveys)-(.+)\..+\.eks\.hotjar\.com$/
    );

    return reviewHostMatch && reviewHostMatch[2];
};

const reviewEnvironmentId = getReviewEnvIdFromHost();

export const HOSTS_PER_ENV = Object.freeze({
    [ENVIRONMENTS.LIVE]: {
        INSIGHTS: 'insights.hotjar.com',
        SURVEYS: 'surveys.hotjar.com'
    },
    [ENVIRONMENTS.REVIEW]: {
        INSIGHTS: reviewEnvironmentId && `insights-${reviewEnvironmentId}.review.eks.hotjar.com`,
        SURVEYS: reviewEnvironmentId && `surveys-${reviewEnvironmentId}.review.eks.hotjar.com`
    },
    [ENVIRONMENTS.REVIEW_WEBAPP]: {
        INSIGHTS: reviewEnvironmentId && `insights-webapp-${reviewEnvironmentId}.review.eks.hotjar.com`,
        SURVEYS: reviewEnvironmentId && `surveys-webapp-${reviewEnvironmentId}.review.eks.hotjar.com`
    },
    [ENVIRONMENTS.STAGING]: {
        INSIGHTS: 'insights-staging.hotjar.com',
        SURVEYS: 'surveys-staging.hotjar.com'
    },
    [ENVIRONMENTS.DEV]: {
        INSIGHTS: 'local.hotjar.com:8443',
        SURVEYS: 'surveys.local.hotjar.com:8443'
    },
    [ENVIRONMENTS.DEV_OLD]: {
        INSIGHTS: 'local.hotjar.com',
        SURVEYS: 'surveys.local.hotjar.com'
    }
});

const isEnvironment = (environment) => (host, hostType) => host === HOSTS_PER_ENV[environment][hostType];

const isDev = isEnvironment(ENVIRONMENTS.DEV);
const isDevOld = isEnvironment(ENVIRONMENTS.DEV_OLD);
const isLive = isEnvironment(ENVIRONMENTS.LIVE);
const isReviewWebapp = isEnvironment(ENVIRONMENTS.REVIEW_WEBAPP);
const isReview = isEnvironment(ENVIRONMENTS.REVIEW);
const isStaging = isEnvironment(ENVIRONMENTS.STAGING);

export const getEnvironment = (hostType = 'INSIGHTS', host = document.location.host) => {
    if (isLive(host, hostType)) {
        return ENVIRONMENTS.LIVE;
    }

    if (isDev(host, hostType)) {
        return ENVIRONMENTS.DEV;
    }

    if (isDevOld(host, hostType)) {
        return ENVIRONMENTS.DEV_OLD;
    }

    if (isReviewWebapp(host, hostType)) {
        return ENVIRONMENTS.REVIEW_WEBAPP;
    }

    if (isReview(host, hostType)) {
        return ENVIRONMENTS.REVIEW;
    }

    if (isStaging(host, hostType)) {
        return ENVIRONMENTS.STAGING;
    }

    return ENVIRONMENTS.LIVE;
};
